export default __webpack_public_path__ + "static/media/meater.e6914c54.svg";